import pluralize from 'pluralize'

export const SOURCES_AVATAR_GROUP_LABELS = {
  intakeRequestBasis: 'Based on information provided in the intake request.',
  lemaSmartEstimation: 'Lema smart estimation',
} as const

export const permissionLabel = (count: number) => pluralize('Permission', count)

export const morePermissionsLabel = (count: number) => `+${count} more`

export const attackSurfacePhrase = (isPlural: boolean, claim: string) =>
  `${isPlural ? 'grant' : 'grants'} ${claim}, increasing your organization's attack surface exposure.`

export const dataAccessPhrase = (isPlural: boolean, claim: string) =>
  `${isPlural ? 'allow' : 'allows'} to access ${claim}`

export const defaultPermissionPhrase = (claim: string) => `allows ${claim}`
